import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/** Supplies the workflow name for /workflows/:id and the selected journey for /journey-templates to the layout breadcrumb. */
@Injectable({ providedIn: 'root' })
export class WorkflowDetailBreadcrumbService {
    private readonly _label$ = new BehaviorSubject<string | null>(null);

    readonly label$ = this._label$.asObservable();

    setWorkflowLabel(label: string | null): void {
        this._label$.next(label);
    }

    getWorkflowLabel(): string | null {
        return this._label$.value;
    }

    private readonly _journey$ = new BehaviorSubject<string | null>(null);

    readonly journey$ = this._journey$.asObservable();

    setJourneyLabel(label: string | null): void {
        this._journey$.next(label);
    }

    getJourneyLabel(): string | null {
        return this._journey$.value;
    }
}
